import { Horario } from '@/types'

export const getEstadoHorario = (horarios: Horario[]) => {
  const now = new Date()

  const diaJS = now.getDay()
  const diaActual = diaJS === 0 ? 7 : diaJS
  const diaAyer = diaActual === 1 ? 7 : diaActual - 1

  const horaActual = now.getHours() * 60 + now.getMinutes()

  const hoy = horarios.filter(
    h => Number(h.dia_semana) === diaActual && h.activo
  )

  const ayer = horarios.filter(
    h => Number(h.dia_semana) === diaAyer && h.activo
  )

  const abiertoHoy = hoy.some(h => {
    const [hiH, hiM] = h.hora_inicio.split(':').map(Number)
    const [hfH, hfM] = h.hora_fin.split(':').map(Number)

    const inicio = hiH * 60 + hiM
    const fin = hfH * 60 + hfM

    if (inicio < fin) {
      return horaActual >= inicio && horaActual < fin
    }

    return horaActual >= inicio || horaActual < fin
  })

  // 🔥 comprobar si sigue abierto por horario de ayer que cruza medianoche
  const abiertoAyer = ayer.some(h => {
    const [hiH, hiM] = h.hora_inicio.split(':').map(Number)
    const [hfH, hfM] = h.hora_fin.split(':').map(Number)

    const inicio = hiH * 60 + hiM
    const fin = hfH * 60 + hfM

    if (inicio > fin) {
      return horaActual < fin
    }
    return false
  })

  const abiertoAhora = abiertoHoy || abiertoAyer

  const tramosTexto = hoy
    .map(h => `${h.hora_inicio.slice(0, 5)} – ${h.hora_fin.slice(0, 5)}`)
    .join(', ')

  return {
    abierto: abiertoAhora,
    texto: abiertoAhora
      ? `Abierto ahora · Horario: ${tramosTexto || "—"}`
      : hoy.length
      ? `Cerrado · Hoy: ${tramosTexto}`
      : "Cerrado hoy",
  }
}